import classNames from 'classnames';
import styles from './answer.module.scss';

interface IAnswer {
  title?: string;
  answer: string;
}
function Answer({title, answer}: IAnswer) {
  return (
    <div className={classNames(styles['answer'], 'p-3')}>
      {title ? (
        <small className="color-red-3 pb-3">فروشگاه {title} : </small>
      ) : (
        ''
      )}
      <div className="color-gray-1 ">{answer}</div>
    </div>
  );
}

export default Answer;
